import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { event } from 'jquery';
import Select from 'react-select';
import getDecryptData from '../../../helpers/getDecryptData';

const LeadCreate = () => {
  const navigate = useNavigate();
   const decryptdatajson = getDecryptData();
   const Empid = decryptdatajson?._id;

  const [Lpro, setLPro] = useState([]);


    const fetchData = async () => {
    try {
       const response = await axiosInstance.get(
        `/admin/all-lead-product-fillter?page=1&limit=1000000&search=`
      );
      setLPro(response.data.Department);
     
     } catch (error) {
      setLPro([])
     } 
  };

  useEffect(() => {
    fetchData();
  }, []);


  const [addHistory, setAddHistory] = useState([]);
       const [commentStatus, setCommentStatus] = useState(false);
       const [commentEmployee, setCommentEmployee] = useState(null);
       const [MyComment, setMyComment] = useState('');


  const SubmitHistory = async (changes,comment,id,working) => {
    const now = new Date();
   
  const decryptdatajson = getDecryptData();
        
  const updatedHistory = { 
    date: now.toLocaleDateString(), // e.g., 5/1/2025
    time: now.toLocaleTimeString(), // e.g., 10:10:30 AM
    userId: decryptdatajson._id,
    name: decryptdatajson.username,
    phone: decryptdatajson.phone,
    changes,
    comment,
    assignId : id || null,
    working : working || '',
   };
  
  setAddHistory([...addHistory, updatedHistory]);
  console.log('updatedHistoryupdatedHistory',updatedHistory)
  }
  


  
    const handleChangeComment = () => {
      if(!formData.formcomment || formData.formcomment === ''  ){
        toast.error('Please type comment');
      }else{
  
        if( !formData.working || formData.working === '' ){
        toast.error('Please Choose Working Status');
        }else{
    SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment} - ${formData.working === '1' ? 'working' : 'On leave'}`,formData.employeeId,formData.working);
       setCommentStatus(false);
          setFormData((prevData) => ({
          ...prevData,
          'formcomment': null,
          'working' : null,
        }));

        }
   
      }
  
    }
  


  const [AllProducts, setAllProducts] = useState([]);

  const getUserAllPro = async () => {
    try {
        const response = await axiosInstance.get(`/all-products?type=1`);

        setAllProducts(response.data.products);
        console.log('setAllProducts', response.data.products)

    } catch (error) {
        console.error('Error fetching user products:', error);
    } 
};



  const [AllUser, setAllUser] = useState([]);
  const [AddProduct, setAddProduct] = useState([]);

  const [AddRental, setAddRental] = useState([]);
  const [AddReceived, setAddReceived] = useState([]);
  const [AddReturn, setAddReturn] = useState([]);


  const [UserId, setUserId] = useState(null);
  const [AllEmployee, setAllEmployee] = useState([]);

  const [AllSaleEmployee, setAllSaleEmployee] = useState([]);


  const [UserDetails, setUserDetails] = useState({});

  
  const [OrderId, setOrderId] = useState(null);


const [formData, setFormData] = useState({
  Ldate: new Date().toISOString().split('T')[0], // Format: YYYY-MM-DD
  Ltime: new Date().toTimeString().slice(0, 5)   // Format: HH:MM
});

  
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0); // Default discount is 0
    const [shipping, setShipping] = useState(0); // Default discount is 0
    const [finalTotal, setFinalTotal] = useState(0);
    const [taxTotal, setTaxTotal] = useState(0);

    const [applyIGST, setApplyIGST] = useState(false);
    const [applyCGST, setApplyCGST] = useState(false);
    const [applySGST, setApplySGST] = useState(false);

    const handleClearClick = () => {
      setSearchQuery("");
    };

    const handleDiscountChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setDiscount(value);
    };

    const handleShippingChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setShipping(value);
    };
    
    const handleAddProduct = (product) => {
          if (id === '1' && product.stock <= 0) {
              toast.error('Product is out of stock');
              return null;   
            }else if( product.reStock <= 0){
              toast.error('Product is out of stock');
              return null;  
            }
      let ProductCost = 0;
      // if(formData.diffDays && formData.diffDays > 0){
      //  if(formData.diffDays < 8){
      //   ProductCost = product.oneto7 ? product.oneto7 : product.salePrice ;
      //  }else if(formData.diffDays < 15){
      //   ProductCost = product.eightto14 ? product.eightto14 : product.salePrice ;
      //  }else if(formData.diffDays < 30){
      //   ProductCost = product.fivto30 ? product.fivto30 : product.salePrice ;
      //  }else if(formData.diffDays < 90){
      //   ProductCost = product.monthto3month ? product.monthto3month : product.salePrice ;
      //  }else if(formData.diffDays < 180){
      //   ProductCost = product.threemonthto6month ? product.threemonthto6month : product.salePrice ;
      //  }else{
      //   ProductCost = product.salePrice;
      //  }
      //  ProductCost = formData.diffDays * ProductCost;
      // }
      // console.log('ProductCost',ProductCost);
      // console.log('formData.diffDays',formData.diffDays);

      const updatedProduct = {
        ...product,
        quantity: 1,
        amount: ProductCost,
        total: ProductCost,
       tax: id === '1' ? product.gst : product.Rentalgst || 0 ,
      };
      setAddProduct([...AddProduct, updatedProduct]);
      setSearchQuery("");
    };


    

      const handleAddRental = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
          };
    
          setAddRental([...AddRental, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
    
        const handleAddReceived = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }

        if(id === '4' && !formData.days){ 
       toast.error('No. of days is required');
       return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
            days : formData.days,
          };
    
          setAddReceived([...AddReceived, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
    
        const handleAddReturn = () => {
          if( !formData.raMethod ){
        
          if(!formData.raDate){
            toast.error('Date is required')
          } else if(!formData.raTime){
            toast.error('Time is required')
          }else if(!formData.raAmount){
            toast.error('Amount is required')
          }else if(!formData.raMethod){
            toast.error('Payment method is required')
          }
        return null;
        }
          const updatedData = {
            date: formData.raDate,
            time: formData.raTime,
            gateway: formData.raGateway,
            amount: formData.raAmount,
            method: formData.raMethod,
            transaction: formData.raTransaction,
            comment: formData.raComment,
            checkNo: formData.raCheckNo,
            bankName: formData.raBankName,
            chequeAmount: formData.raChequeAmount,
            chequeDate: formData.raChequeDate,  
            authSignatoryName: formData.raAuthSignatoryName,
          };
    
          setAddReturn([...AddReturn, updatedData]);
          setFormData((prevData) => ({
            ...prevData,
            raDate: '',
            raTime: '',
            raGateway: '',
            raAmount: '',
            raMethod: '',
            raTransaction: '',
            raComment: '',
            raCheckNo: '',
            raBankName: '',
            raChequeAmount: '',
            raChequeDate: '',
            raAuthSignatoryName: '',
          }));
    
        }
        
        const handleEditRental = (index) => {
          const selectedData = AddRental[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',

            raindex: index
          }));
        };
    
            
        const handleEditReceived = (index) => {
          const selectedData = AddReceived[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',
            days: selectedData.days || '',
            raindex: index
          }));
        };
    
        const handleEditReturn = (index) => {
          const selectedData = AddReturn[index];
        
          setFormData((prevData) => ({
            ...prevData,
            raDate: selectedData.date || '',
            raTime: selectedData.time || '',
            raGateway: selectedData.gateway || '',
            raAmount: selectedData.amount || '',
            raMethod: selectedData.method || '',
            raTransaction: selectedData.transaction || '',
            raComment: selectedData.comment || '',
            raCheckNo: selectedData.checkNo || '',
            raBankName: selectedData.bankName || '',
            raChequeAmount: selectedData.chequeAmount || '',
            raChequeDate: selectedData.chequeDate || '',
            raAuthSignatoryName: selectedData.authSignatoryName || '',
            raindex: index
          }));
        };

    
    const ResetRentalInputs = () => {
      setFormData((prevData) => ({
        ...prevData,
        raDate: '',
        raTime: '',
        raGateway: '',
        raAmount: '',
        raMethod: '',
        raTransaction: '',
      }));

    }

 
     const handleUpdateRental = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddRental];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           setAddRental(updatedData);
        }
        const handleUpdateReceived = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddReceived];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           updatedData[index].days =  formData.days; 

           setAddReceived(updatedData);
        }
    
        const handleUpdateReturn = (index) => {
          if( !formData.raMethod ){
        
            if(!formData.raDate){
              toast.error('Date is required')
            } else if(!formData.raTime){
              toast.error('Time is required')
            }else if(!formData.raAmount){
              toast.error('Amount is required')
            }else if(!formData.raMethod){
              toast.error('Payment method is required')
            }
          return null;
          }
    
          const updatedData = [...AddReturn];
           updatedData[index].date = formData.raDate;
           updatedData[index].time = formData.raTime;
           updatedData[index].gateway = formData.raGateway;
           updatedData[index].amount =  formData.raAmount;
           updatedData[index].method =  formData.raMethod;
           updatedData[index].transaction =  formData.raTransaction;
           updatedData[index].comment =  formData.raComment; 
           updatedData[index].checkNo =  formData.raCheckNo; 
           updatedData[index].bankName =  formData.raBankName; 
           updatedData[index].chequeAmount =  formData.raChequeAmount; 
           updatedData[index].chequeDate =  formData.raChequeDate; 
           updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
           setAddReturn(updatedData);
        }


    const handleRemoveRental = (index) => {
      const updatedData = [...AddRental];
      updatedData.splice(index, 1);
      setAddRental(updatedData);
    };


    const handleRemoveReceived = (index) => {
      const updatedData = [...AddReceived];
      updatedData.splice(index, 1);
      setAddReceived(updatedData);
    };

    const handleRemoveReturn = (index) => {
      const updatedData = [...AddReturn];
      updatedData.splice(index, 1);
      setAddReturn(updatedData);
    };

    
    const handleRemoveProduct = (index) => {
      const updatedProducts = [...AddProduct];
      updatedProducts.splice(index, 1);
      setAddProduct(updatedProducts);
    };
    
    const handleQuantityChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const quantity = parseInt(value) || 1;
      const price = updatedProducts[index].amount || 0;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].quantity = quantity;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

    const handleSerialNumberChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const serialNumber = value; 
      updatedProducts[index].serialNumber = serialNumber;
       setAddProduct(updatedProducts);
    };
    


    const handleAmtChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const newAmount = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].amount = newAmount;
      updatedProducts[index].total = quantity * newAmount * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

    const handleTaxChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const tax = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const price = updatedProducts[index].amount || 0;
    
      updatedProducts[index].tax = tax;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
    };

      const [searchQuery, setSearchQuery] = useState("");
    
      const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
      };
    
  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const filteredProducts = AllProducts?.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleUserChange = (userId) => {
     const selectedUser = AllUser.find((user) => user._id === userId);
     console.log('AllUser',userId, AllUser)

    if (selectedUser) {
      setUserDetails({
        id: selectedUser._id,
        name: selectedUser.username,
        email: selectedUser.email,
        phone: selectedUser.phone,
      });
     }
  };
  
  
  const handleChange = (e) => {
    const { name, value, type, checked,label } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    } 

   
    if(name === 'PickupDate' &&  formData.days){
   
       const dateValue = newValue;
       const returnvalue =  addDaysToDate(dateValue, formData.days);
       console.log('returnvalue',returnvalue);
       console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
       setFormData((prevData) => ({
        ...prevData,
        'ReturnDate': returnvalue,
      }));
      
    }
     else if (name === "employeeId" ) {
      newValue = value;
      // SubmitHistory('Update Employee ( Doctor / Nurse / Runner )', `username : ${label}`);
      setCommentStatus(true);
      setCommentEmployee(label);
      setMyComment('Update Employee ( Doctor / Nurse / Runner )');
    } 
    
    if (name === "days" ) {
      let myvalue;
      if(1 > newValue ){
        myvalue = 1
      }else{
        myvalue = newValue;
      }
      setFormData((prevData) => ({
        ...prevData,
        [name]: myvalue,
      }));

if(formData.PickupDate){
  const returnvalue =  addDaysToDate(formData.PickupDate, myvalue);
  console.log('returnvalue',returnvalue);
  console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
  setFormData((prevData) => ({
   ...prevData,
   'ReturnDate': returnvalue,
 }));
}
     
     
    }else{
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    }
  
   };

  const handleUserDataChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }

     if(name === 'phone'){
      fetchUserPhoneData(newValue);
     }

    setUserDetails((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };
  

// const selectUser = async (OrderId, User,cat,type,distance) => {
//   fetchemployeeData(cat,type,distance);
//   setOrderId(OrderId);
//   setUserId(User);
//  }
 

const fetchUserPhoneData = async (phone) => {
  if(phone.length === 10){
  
   try {
    const response = await axiosInstance.get(`/all-employee?&type=none&filter=none&phone=${phone}`);
    const { success, Users } = response.data;
    if (success) {
      if(Users && Users[0]){
        const data = Users[0];
        setUserDetails({
          id: data._id,
          name: data.username || '',
          email: data.email || '',
          phone: data.phone || '',
          address: data.address,
          gender: data.gender,
          company: data.company,
          companyName: data.companyName,
          companyGST: data.companyGST,
          companyAddress: data.companyAddress,
          age: data.age,
          weight: data.weight,
        });
      }
      toast.success('User Found');
      console.log('Users',response.data);
      }else{
        toast.success('New User Found');
        setUserDetails({
          id: 'none',
          name:'',
          email: '',
          address: '',
          gender: '',
          phone : phone,
        });
      }

  } catch (error) {
    console.error('Error fetching User:', error);

  }
  
}

};


const fetchSaleEmployeeData = async () => {

  setAllSaleEmployee
  ([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=2`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllSaleEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

const fetchEmployeeData = async (id) => {

  setAllEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=${id}`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};


   const { id } = useParams();
 

  const getUserOrders = async () => {

    try {

       // const { data } = await axiosInstance.get(`/user-orders-view/${userId}/${orderId}`);

      // if (data?.success) {
      //   console.log('order', data)
      //   setOrder(data?.userOrder);

      // }
      // setIsLoading(false);  

    } catch (error) {
    //  console.log(error);
     // setIsLoading(false); // Set loading state to false in case of an error
    //  toast.error("order Not found");
   
    }
  };

  useEffect(() => {
     getUserOrders();
getUserAllPro();
fetchSaleEmployeeData();
fetchEmployeeData(id);
  }, []);

    useEffect(() => {
      setAllEmployee([]);
      setFormData((prevData) => ({
        ...prevData,
        employeeId: null,
        order :id,
      }));

      if(formData.order ){
        if( formData.order !== '2'){
          fetchEmployeeData(formData.order);
        }else{ 
          fetchEmployeeData();
        }
      }
     }, [formData.order,id]);
  
  
  useEffect(() => {
  console.log('UserDetails',UserDetails.length)
  }, []);

  
  useEffect(() => {
    const newSubtotal = AddProduct.reduce((acc, item) => acc + (item.total || 0), 0);
    setSubtotal(newSubtotal);

    let totalTax = 0;

    AddProduct.forEach(item => {
      const baseAmount = item.quantity * item.amount;
      const taxRate = item.tax || 0;

      if (applyIGST) {
        totalTax += baseAmount * (taxRate / 100);
      } else {
        if (applyCGST) totalTax += baseAmount * (taxRate / 100) / 2;
        if (applySGST) totalTax += baseAmount * (taxRate / 100) / 2;
      }
    });

    setTaxTotal(totalTax);

    const calculatedFinalTotal = newSubtotal - discount + shipping ;
    setFinalTotal(calculatedFinalTotal >= 0 ? calculatedFinalTotal : 0);
  }, [AddProduct, discount, shipping, applyIGST, applyCGST, applySGST]);

  useEffect(() => {

  if (formData.PickupDate && formData.ReturnDate) {
    const pickupDate = new Date(formData.PickupDate);
    const returnDate = new Date(formData.ReturnDate);
    const diffTime = returnDate - pickupDate;
    const diffDays = diffTime / (1000 * 3600 * 24);
    setFormData((prevData) => ({
      ...prevData,
      diffDays:diffDays+1,
      days:diffDays+1,
    })); 
    }
}, [formData.PickupDate,formData.ReturnDate]);


  
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state



  const submitData = async () => {
    console.log('UserDetails',UserDetails)

   
    // Check if UserDetails is an object and has the necessary properties filled
    if (!UserDetails || Object.keys(UserDetails).length === 0 || 
        !UserDetails.name || 
        !UserDetails.phone || 
        !UserDetails.email   
      ) {
        
        toast.error('Please Fill in all user details');
        return null;
    }

    
    if(!formData.type){
       toast.error('Please choose Lead Type');
       return null;
  }

    if(!formData.Ldate){
       toast.error('Please choose Lead Date');
       return null;
  }
    
      if(!formData.Ltime){
       toast.error('Please choose Lead Time');
       return null;
  }
     if(!formData.product){
       toast.error('Please choose product');
       return null;
  }
  if(!formData.source){
       toast.error('Please choose source');
       return null;
  }

    setSubmitLoading(false);
  
    let order = null;
    if(!formData.order){
      order = id;
    }else{
      order = formData.order;
    }
    let employeeSaleId;
    if(decryptdatajson.empType === 2){
      employeeSaleId = decryptdatajson._id;
    }else{
      employeeSaleId = formData.employeeSaleId;
    }
   const updatedFormData = {
      ...formData,
      status: 1,
      addProduct: AddProduct,
      addRentalL: AddRental,
      addReceived: AddReceived,
      addReturn: AddReturn,
      discount: discount,
      shipping: shipping,
      applyIGST: applyIGST,
      applyCGST: applyCGST,
      applySGST: applySGST,
      userId : UserId,
      UserDetails,
      subtotal,
      finalTotal,
      taxTotal,
      addHistory: addHistory, // Combine old and new history
      employeeSaleId : employeeSaleId,
    };

    try {

      await axiosInstance.post('/admin/add-lead', updatedFormData);
      console.log('Lead Create successfully!');
      toast.success('Lead Created successfully!'); 
      navigate(`/all-lead`); 
    } catch (error) {
      console.error('Error On Creating lead:', error);
      console.log(formData);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const userOptions = AllUser.map(user => ({
    value: user._id,
    label: user.username
  }));
  const employeeSaleOptions = AllSaleEmployee.map(emp => ({
    value: emp._id,
    label: emp.username + ` (${emp.phone})` 
  }));

  // Format employee list for react-select
const employeeOptions = AllEmployee.map(emp => ({
  value: emp._id,
  label: emp.username + ` (${emp.phone})` 
}));

function addDaysToDate(dateStr, days) {
  console.log("Input dateStr:", dateStr);
  console.log("Days to add:", days);

  if (!dateStr || isNaN(days)) {
    console.warn("Invalid input to addDaysToDate");
    return "";
  }

  const cleanDateStr = dateStr.split(" ")[0];
  const [year, month, day] = cleanDateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + Number(days)); // Ensure days is treated as a number

  const result = date.toISOString().split("T")[0];
  console.log("Output date:", result);
  return result;
}
 

  return (
    <>
      <Sidebar />
      <main class="content">
        <Navbar />


    <div className="py-4">
          <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
              <li className="breadcrumb-item">
                <a href="#">
                  <svg
                    className="icon icon-xxs"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                </a>
              </li>
              <li className="breadcrumb-item">
                <a href="#">Admin</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Create Lead
              </li>
            </ol>
          </nav>
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="mb-3 mb-lg-0">
              <h1 className="h4">Create Lead </h1>
            </div>
            <div>
              {" "}
              <Link
                type="button"
                to={'/all-order'}
                className="btn btn-primary d-inline-flex align-items-center"
              >
                <svg
                  style={{ transform: "rotate(180deg)" }}
                  className="icon icon-sm"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
                Go back
              </Link>
            </div>
          </div>
        </div>

{commentStatus && 

    <div
              className="modal fade show"
              id="modal-userr"
              tabIndex={999}
              aria-labelledby="modal-userr"
              style={{ display: "block" ,backgroundColor:'#0000004a'}}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

   <div className="col-md-12">
                  <label className="mb-2"> Select Working Status</label>

                  <ul className="customradio input-group d-flex gap-2  mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="1"
                        checked={formData.working === "1"}
                      />
                      <label>Working</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="0"
                        checked={formData.working === "0"}
                      />
                      <label>On Leave  </label>
                    </li>
                    
                  </ul>
                </div>
                
     <div className='col-md-12'>
 



 <div className="mb-4">
   <label htmlFor="formcomment"> Comment  <span className='text-danger'> ( Required )</span> </label>

   <textarea
  
     className="form-control"
     id="formcomment" value={formData.formcomment}
     name="formcomment" 
     onChange={handleChange}
      />
 </div>
</div>  
 
                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      
                      
                      onClick={()=>{setCommentStatus(false)}}
                    >
                      Close
                    </button>

                    <button type="button" class="btn btn-primary ms-auto" onClick={handleChangeComment} > Update Employee </button>

                  </div>
                </div>
              </div>
            </div>

}

        <div
              className="modal fade"
              id="modal-user"
              tabIndex={-1}
              aria-labelledby="modal-user"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

                  <div className="row mb-0">
                      
                  <div className='col-md-6'> 
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="name" value={UserDetails.name}
     name="name" 
     onChange={handleUserDataChange}
      />
 </div>
</div>                   

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="email" value={UserDetails.email}
     name="email" 
     onChange={handleUserDataChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Phone <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="phone" value={UserDetails.phone}
     name="phone" 
     onChange={handleUserDataChange}
      />
 </div>
</div>   

 

<div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender  <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={UserDetails.gender}
                        name="gender"
                        onChange={handleUserDataChange}
                      >
                        <option selected value="">
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>


                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="Address"> Address  </label>

   <input
     type="text"
     className="form-control"
     id="address" value={UserDetails.address}
     name="address" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


 <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Weight  </label>

   <input
     type="text"
     className="form-control"
     id="weight" value={UserDetails.weight}
     name="weight" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="disease"> Disease    </label>

   <textarea
     type="text"
     className="form-control"
     id="disease" 
     name="disease" 
     onChange={handleUserDataChange}
      >{UserDetails.disease}</textarea>
 </div>
</div>  

                    </div>

                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-rental"
              tabIndex={-1}
              aria-labelledby="modal-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>


                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddRental}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-Received"
              tabIndex={-1}
              aria-labelledby="modal-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        

    { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 
              </>
                  }

                  
 {id === '4' && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}
    

                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReceived}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-Return"
              tabIndex={-1}
              aria-labelledby="modal-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReturn}
                    >
                      Add Return
                    </button>
                  </div>
                </div>
              </div>
            </div>



            <div
              className="modal fade"
              id="modal-edit-rental"
              tabIndex={-1}
              aria-labelledby="modal-edit-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateRental(formData.raindex)}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-edit-Received"
              tabIndex={-1}
              aria-labelledby="modal-edit-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        


            <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="days"> No. of days <span className='text-danger'>*</span>  </label>

<input
type="number"
className="form-control"
id="days" value={formData.days}
name="days" 
onChange={handleChange}
 
/>
</div>
</div> 


   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReceived(formData.raindex)}
                    >
                      Update Security
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-edit-Return"
              tabIndex={-1}
              aria-labelledby="modal-edit-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReturn(formData.raindex)}
                    >
                      Update Return
                    </button>
                  </div>
                </div>
              </div>
            </div>


 <div className='card p-3'>
 
 <div className='row mt-0'>

 
 <div className="mb-4">
 <div className='col-md-4'>

 <label htmlFor="eventTitle">
                     
                     Lead Type 
                   </label>{" "}

                   <select
                     className="form-control select"
                     name="type"
                     style={{ width: "100%" }} 
                      value={formData.type}
                      onChange={handleChange}
                   >
                     <option disabled selected> Select type</option>
                     <option value={1} > Order</option>
                     <option value={2} > Rental </option>
                     <option value={3} > Doctors appointment </option>
                     <option value={4} > Nurse </option> 
                     </select>

 </div> 
     </div>
 


<div className="row mb-0 bg-light p-2 pt-3 mx-0 border rounded mb-2">
                      
<div className='col-md-6'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Phones <span className='text-danger'>*</span>  </label>
    
       <input
         type="number"
         className="form-control"
         id="phone" value={UserDetails.phone}
         name="phone" 
         maxLength="10"
      onChange={(e) => {
    const value = e.target.value;
    // Allow only digits and up to 10 characters
    if (/^\d{0,10}$/.test(value)) {
      handleUserDataChange(e);
    }
  }}
         onWheel={(e) => e.target.blur()} // Use a function to handle the wheel event
         onKeyDown={(e) => {
           if (
             e.key === "ArrowUp" ||
             e.key === "ArrowDown"
           ) {
             e.preventDefault(); // Prevent the default action for up/down keys
           }
         }}
         
          />
     </div>
    </div>   
    

                      <div className='col-md-6'>
                 

     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="name" value={UserDetails.name}
         name="name" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>                   
    
    <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="email" value={UserDetails.email}
         name="email" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 
    
    <div className='col-md-3 d-none'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Age <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="age" value={UserDetails.age}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  
     
        
     <div className='col-md-3 d-none'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Weight  </label>
    
       <input
         type="text"
         className="form-control"
         id="weight" value={UserDetails.weight}
         name="weight" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    
    <div className="mb-4 col-md-3 d-none">
                        <label className="form-label text-dark" htmlFor="email">
                          Gender  <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.gender}
                            name="gender"
                            onChange={handleUserDataChange}
                          >
                            <option selected value={''}>
                              {" "}
                              Select Gender
                            </option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="0">Other</option>
                          </select>
                        </div>
                      </div>
    
      <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Do you have Company ? 
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.company}
                            name="company"
                            onChange={handleUserDataChange}
                          >
                            
                            <option value="yes">Yes</option>
                            <option value="no" selected>NO</option>
                           </select>
                        </div>
                      </div>
                     
                      {UserDetails.company === 'yes' && <>
 
                      <div className='col-md-12'/>
                      <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyName"> Company Name  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyName" value={UserDetails.companyName}
         name="companyName" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company GST  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyGST" value={UserDetails.companyGST}
         name="companyGST" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
        <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company Address  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyAddress" value={UserDetails.companyAddress}
         name="companyAddress" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 


                      </>}
    
                      <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="Address"> Address  </label>
    
       <textarea
         type="text"
         className="form-control"
         id="address" value={UserDetails.address}
         name="address" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
 
    
    <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="disease"> Patient Condition    </label>
    
       <textarea
         type="text"
         className="form-control"
         id="disease" 
         name="disease" 
         onChange={handleUserDataChange}
          >{UserDetails.disease}</textarea>
     </div>
    </div>  
    
                        </div>

                       

{/* <div className='col-md-6 d-none'>
 
             

                            <div className="mb-4">
                      <label htmlFor="eventTitle">
                      
                        Choose User
                      </label>{" "}
                      

<div className='d-flex gap-3 align-items-center'>
 
                      <Select
    className="basic-single w-100"
    classNamePrefix="select "
    name="UserId"
    options={userOptions}
    value={userOptions.find(option => option.value === UserId)}
    onChange={(selectedOption) => {
      setUserId(selectedOption.value); // optional tracking
      handleUserChange(selectedOption.value);
    }}
    placeholder="Select User"
    isSearchable
  />
                    
                      {UserDetails && Object.keys(UserDetails).length > 0 && 
  <button className='btn btn-primary btn-sm w-auto' style={{ minWidth: 'max-content' }}
   data-bs-toggle="modal" data-bs-target="#modal-user"
  >
    View Details
  </button>
}
                      </div>

                    


                    </div>

                          </div> */}
                 
                  
 
 <div className='col-md-4 mb-4 d-none'>

 <label htmlFor="eventTitle">
                     
                  Follow-up
                   </label>{" "}

                   <select
                     className="form-control select"
                     name="follow"
                     style={{ width: "100%" }} 
                     value={formData.follow}
                     onChange={handleChange}
                   >
                     <option disabled selected> Select type</option>
                     <option value={1} > Order</option>
                     <option value={2} > Rental </option>
                     <option value={3} > Doctors appointment </option>
                     <option value={4} > Nurse </option>
                   </select>

 </div> 
 
<div className='col-12'/>  
 
  
<div className="mb-4">
  <div className='col-md-4'>
    <label htmlFor="product">Lead Product</label>

    <select
      className="form-control select"
      name="product"
      style={{ width: "100%" }}
      value={formData.product}
      onChange={handleChange}
      id="product"
    >
      <option value="">Select Product</option>
      {Lpro.map((item) => (
        <option key={item.id} value={item.name}>
          {item.name}
        </option>
      ))}
    </select>
  </div>
</div>



 {decryptdatajson.empType !== 2 && 
          <div className='col-md-6'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee ( Sales )
</label>{" "}

<Select
    name="employeeSaleId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeSaleOptions}
    value={employeeSaleOptions.find(option => option.value === formData.employeeSaleId)}
    onChange={(selectedOption) => {
      const event = {
        target: {
          name: 'employeeSaleId',
          value: selectedOption.value
        }
      };
      handleChange(event); // Reuse your existing handleChange logic
    }}
    placeholder="Select Employee"
    isSearchable
  />

</div>

</div>
 }
                 


<div className='col-md-6 d-none'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee {id === '1' && 'Runner'} {id === '2' && 'Runner'} {id === '3' && 'Doctor'}  {id === '4' && 'Nurse'}  
</label>{" "}

<Select
    name="employeeId"
    className="basic-single"
    classNamePrefix="select"
    options={employeeOptions}
    value={employeeOptions.find(option => option.value === formData.employeeId)}
    onChange={(selectedOption) => {
      // Simulate native event to work with handleChange
      const event = {
        target: {
          name: 'employeeId',
          value: selectedOption.value,
         label: selectedOption.label

        }
      };
      handleChange(event);
    }}
    placeholder="Select Employee"
    isSearchable
  />
  
</div>

</div>
 
 

<div className='col-md-12 my-4 d-none'>
<div className='d-flex justify-content-between'>
<h4>History
</h4>
 </div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
    <th>Time</th>
    <th>User details</th>
    <th> Changes </th>
    <th> Commnent </th>
 
  </tr>
</thead>
<tbody>
  {addHistory.length > 0 ? (
    addHistory.map((data, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{data.date}</td>
         <td>{data.time}</td>
         <td>Username: {data.name}  
         </td>
          <td>{data.changes}</td>
         <td>{data.comment }</td>
          
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No History Found</td>
    </tr>
  )}
</tbody>
</table>
</div>
 

</div>
 
 
 <div className='col-md-6 mb-4'>

 <label htmlFor="eventSource">
                     
                     Lead Source 
                   </label>{" "}

                 <select
  className="form-control select"
  name="source"
  style={{ width: "100%" }}
  value={formData.source}
  onChange={handleChange}
  id="eventSource" >
  <option selected value="">Select Source</option>
  <option value=" ">Google Ads</option>
  <option value="Meta Ads">Meta Ads</option>
  <option value="Website Admin">Website Admin</option>
  <option value="Cold Call">Cold Call</option>
  <option value="Whatsapp">Whatsapp</option>
  <option value="Old Client Reference">Old Client Reference</option>
  <option value="Employee Referral">Employee Referral</option>
  <option value="Online Store">Online Store</option>
  <option value="Email">Email</option>
  <option value="Other">Other</option>
  <option value="Justdial">Justdial</option>
  <option value="Direct">Direct</option>
</select>


 </div> 
    
 


 <div className='col-md-3 mb-4'>

 <label htmlFor="eventDate">
                     
                   Lead Date
                   </label> 
<input className="form-control"  id="eventDate"  type='date' value={formData.Ldate}  name="Ldate" onChange={handleChange} />
    

 </div> 

  <div className='col-md-3 mb-4'>

 <label htmlFor="eventTime">
                     
                 Lead  Time
                   </label> 
<input className="form-control" id="eventTime" type='time' value={formData.Ltime}  name="Ltime" onChange={handleChange} /> 

 </div>

 
 <div className='col-md-3 mb-4'>

 <label htmlFor="eventDate">
                     
                       Follow up Date
                   </label> 
<input className="form-control"  id="eventDate"  type='date' value={formData.date}  name="date" onChange={handleChange} />
    

 </div> 



  <div className='col-md-3 mb-4'>

 <label htmlFor="eventTime">
                     
                       Follow up Time
                   </label> 
<input className="form-control" id="eventTime" type='time' value={formData.time}  name="time" onChange={handleChange} /> 

 </div>

  <div className='col-md-4 mb-4'>

 <label htmlFor="reDate">
                     
                     Requirement Date
                   </label> 
<input className="form-control"  id="reDate"  type='date' value={formData.reDate}  name="reDate" onChange={handleChange} />
    

 </div> 

 <div className='col-md-4 mb-4'>

 <label htmlFor="priceQ">
                     
                      Price Quoted 
                   </label> 
<input className="form-control"  id="priceQ"  type='number' value={formData.priceQ}  name="priceQ" onChange={handleChange} />
     
 </div>

  <div className='col-md-4 mb-4'>

 <label htmlFor="customerEx"> 
                       Customer Expected Price 
                   </label> 
<input className="form-control"  id="customerEx"  type='number' value={formData.customerEx}  name="customerEx" onChange={handleChange} />
    
 </div>



  <div className='col-md-6 mb-4'>

 <label htmlFor="eventComment"> Comment </label> 
<textarea className="form-control" id="eventComment"   value={formData.comment}  name="comment" onChange={handleChange} /> 
 
 </div> 

 
  <div className='col-md-6 mb-4'>

 <label htmlFor="eventRequirement"> Requirement </label> 
<textarea className="form-control"
 id="eventRequirement"  value={formData.requirement}  name="requirement"
 onChange={handleChange} /> 
 
 </div> 

<div className="col-12 mt-4">

{SubmitLoading ? (

  <button className="btn btn-secondary" type="button" onClick={submitData} >
    Create Lead
  </button>
) : (

  <button class="btn btn-secondary btn-sm" type="button" disabled>
    <span class="ms-1">Loading...</span>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>

)}


</div>



      </div>

 </div>
   

      </main>
    </>
  )
}

export default LeadCreate